import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";
import { handleResponseError } from '../../../utils/helpers/network-error';

export const createHour = createAsyncThunk('hours.createAsAdmin', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { newHour, message }} = await api.hours.createAsAdmin(formData);
    onSuccess(message);
    return newHour;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const updateHour = createAsyncThunk('hours.updateAsAdmin', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { _id, ...rest } = formData;

    const formDataWithoutEmptyFields = Object.keys(rest).reduce((acc, key) => {
      if (rest[key]) {
        acc[key] = rest[key];
      }
      return acc;
    }, {});

    const { data: { updatedHour, message }} = await api.hours.updateAsAdmin(_id, formDataWithoutEmptyFields);
    onSuccess(message);
    return updatedHour;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const getHours = createAsyncThunk('hours.getHoursAsAdmin', async ({
  page, limit, search, userIds, dateRange
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (search && search.trim().length > 0) {
      queryParams.search = search.trim();
    }

    if (userIds && userIds.length > 0) {
      queryParams.userIds = userIds;
    }

    if (dateRange) {
      queryParams.startDate = dateRange.startDate;
      queryParams.endDate = dateRange.endDate;
    }

    const { data: { hours, totalMinutes, totalSalaries, totalDocs }} = await api.hours.getHoursAsAdmin(queryParams);
    
    return {
      hours,
      totalMinutes,
      totalSalaries,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const deleteHours = createAsyncThunk('hours.deleteHoursAsAdmin', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.hours.deleteHoursAsAdmin(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});
